export default "__VITE_ASSET__FgCDPgX2__"